import template from './organizationChange.template.html';

export default {
  controller: class controller {
    constructor(
      $state,
      $rootScope,
      $mdDialog,
      $filter,
      eventService,
      navigationService,
      uiService,
      INSTANCE
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.AvailableOrganizations = [];
      ctrl.CurrentOrganization = null;
      ctrl.$mdDialog = $mdDialog;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onOrganizationChange(function (_params) {
          ctrl.AvailableOrganizations = $rootScope.AvailableOrganizations
            ? $rootScope.AvailableOrganizations
            : [];
          ctrl.CurrentOrganization = $rootScope.CurrentOrganization;

          $mdDialog.show({
            targetEvent: _params.event,
            locals: {
              organizations: _.reject(ctrl.AvailableOrganizations, function (o) {
                return o.id === ctrl.CurrentOrganization.id;
              })
            },
            template,
            controllerAs: '$ctrl',
            controller: dialogController
          });

          function dialogController($mdDialog, $rootScope, INSTANCE, organizations) {
            this.INSTANCE = INSTANCE;
            this.isEnterprise = $rootScope.IsEnterprise;
            this.organizations = $filter('orderBy')(organizations, function (organization) {
              return organization.getName();
            });
            this.confirm = function (name, id, url) {
              $mdDialog.cancel();
              uiService.toast({
                text: {
                  p1: 'Switching to',
                  p2: name,
                  p3: 'organization'
                }
              });
              $state.transitionTo('organizationSwitch');
              navigationService.organizationChange({ idOrganization: id, url: url });
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
